import { render } from "./Rol_RolPerfil.vue?vue&type=template&id=d4fb4088"
import script from "./Rol_RolPerfil.vue?vue&type=script&lang=js"
export * from "./Rol_RolPerfil.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__